import { lazy } from 'react';

export const QuestionBankList = lazy(() => import('./QuestionBankList'));
export const AddQuestionBank = lazy(() => import('./AddQuestionBank'));
export const UpdateQuestionBank = lazy(() => import('./UpdateQuestionBank'));
export const QuestionBankDetails = lazy(() => import('./QuestionBankDetails'));
